export default {
  namespaced: true,
  state: {
    version: '0.0.8',
    tables: {
      requests: {
        itemsPerPage: 10,
      },
      requestsActivities: {
        itemsPerPage: 10,
      },
      userList: {
        itemsPerPage: 10,
      },
      plannedOutageList: {
        itemsPerPage: 10,
      },
      agreementAttachmentList: {
        itemsPerPage: 10,
      },
    },
    tabs: {
      selectedTab: 0,
    },
    filters: {
      requests: {},
      accountOverview: {},
    },
  },
  mutations: {
    TABLE_ITEMS_UPDATE(state, { tableName, itemsPerPage }) {
      state.tables[tableName].itemsPerPage = itemsPerPage;
      localStorage.setItem('settings', JSON.stringify(state));
    },
    TABS_SELECTION(state, tab) {
      state.tabs.selectedTab = tab;
      localStorage.setItem('settings', JSON.stringify(state));
    },
    FILTER_UPDATE(state, { key, value }) {
      state.filters[key] = value;
      localStorage.setItem('settings', JSON.stringify(state));
    },
  },
};
